






import Component, { mixins } from 'vue-class-component';
import AbstractAnimated from './abstract-animated.vue';
import { humanReadAbleChargingTime } from '../../utils/time-helpers';

@Component({
  name: 'eq-web-animated-hours',
})
export default class AnimatedHours extends mixins(AbstractAnimated) {
  private get humanReadAbleChargingTime() {
    return humanReadAbleChargingTime(this.displayValue);
  }
}
